// Shipments actions
import axios from 'axios';
import types from '../../types';
/* eslint-disable */
export default {
  // SHIPMENTS
  [types.GET_SHIPMENTS]: async (context, payload) => {
    try {
      await axios.get(`shipment/get-list?page=${payload.page}${payload.query}`).then((res) => {
        if(payload.page == 1){
          context.commit('RESET_STORE_SHIPMENTS', res.data.data);
        } else {
          context.commit('STORE_SHIPMENTS', res.data.data);
        }
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_SHIPMENTS]: ({commit}, payload) => {
    commit('STORE_SHIPMENTS', payload);
  },
  [types.CLEAR_SHIPMENTS]: (context) => {
    context.commit('CLEAR_SHIPMENTS');
  },
  [types.GET_BOOKING_SYSTEMS]: async (context) => {
    try {
      return await axios.get('utilities/get-system-settings').then((res) => {
        context.commit('STORE_BOOKING_SYSTEM', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  // DRAFT SHIPMENTS
  [types.GET_DRAFT_SHIPMENTS]: async (context, payload) => {
    try {
      await axios.get(`shipment/get-draft-list?page=${payload.page}${payload.query}`).then((res) => {
        if(payload.page == 1){
          context.commit('RESET_DRAFT_SHIPMENTS', res.data.data);
        } else {
          context.commit('STORE_DRAFT_SHIPMENTS', res.data.data);
        }
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_DRAFT_SHIPMENTS]: ({commit}, payload) => {
    commit('STORE_DRAFT_SHIPMENTS', payload);
  },
  [types.CLEAR_DRAFT_SHIPMENTS]: (context) => {
    context.commit('CLEAR_DRAFT_SHIPMENTS');
  },
  [types.DELETE_DRAFTS]: async (context, payload) => {
    try {
      if(payload.type == 'byFilter'){
        return await axios.post('shipment/delete-list', {
          search: payload.search,
          searchTerm: payload.searchTerm,
          total_count: payload.count,
        });
      } else if(payload.type == 'byFilterWithExclusions'){
        // New: Handle exclude logic
        return await axios.post('shipment/delete-list', {
          search: payload.search,
          searchTerm: payload.searchTerm,
          total_count: payload.count,
          exclude_only_ids: payload.excludeOnlyIds,
        });
      } else {
        return await axios.delete(`shipment/0/delete?ids=[${payload.ids}]`);
      }
    } catch (err) {
      console.error(err);
    }
  },
  [types.PRINT_DRAFTS]: async (context, payload) => {
    try {
      return await axios.post(`shipment-actions/bulk-agents-print`, {
        shipment_ids: payload.shipment_ids,
        search: payload.search ? JSON.parse(payload.search) : null,
        searchTerm: payload.searchTerm,
        total_count: payload.count,
        exclude_only_ids: payload.excludeOnlyIds,
      }).then((res) => {
        if(res.data.data.processed.length > 0 ) {
          context.dispatch('STORE_IN_QUEUE', {
            progressId: res.data.data.progress_id,
            fileName: 'Booking shipments',
            iconName: 'printer',
          });
        }
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EXPORT_CSV]: async (context, payload) => {
    try {
      var fileCSV;
      if(payload.ids.length > 0){
        fileCSV = await axios.post(`file/download-csv?table_name=${payload.tableName}&ids=[${payload.ids}]`, {responseType: 'text/csv'});
      } else {
        fileCSV = await axios.post(`file/download-csv?table_name=${payload.tableName}${payload.query}`, {responseType: 'text/csv'});
      }
      return fileCSV.data;
    } catch (err) {
      console.error(err);
    }
  },
  // UNAPPROVED SHIPMENTS
  [types.GET_UNAPPROVED_SHIPMENTS]: async (context, payload) => {
    try {
      await axios.get(`shipment/get-unapproved-shipments-list?page=${payload.page}${payload.query}`).then((res) => {
        if(payload.page == 1){
          context.commit('RESET_UNAPPROVED_SHIPMENTS', res.data.data);
        } else {
          context.commit('STORE_UNAPPROVED_SHIPMENTS', res.data.data);
        }
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_UNAPPROVED_SHIPMENTS]: ({commit}, payload) => {
    commit('STORE_UNAPPROVED_SHIPMENTS', payload);
  },
  [types.CLEAR_UNAPPROVED_SHIPMENTS]: (context) => {
    context.commit('CLEAR_UNAPPROVED_SHIPMENTS');
  },
  [types.DELETE_UNAPPROVEDS]: async (context, payload) => {
    try {
      if(payload.type == 'byFilter'){
        return await axios.post('shipment/delete-list', {
          search: payload.search,
          searchTerm: payload.searchTerm,
          total_count: payload.count,
        });
      } else {
        return await axios.delete(`shipment/0/delete?ids=[${payload.ids}]`);
      }
    } catch (err) {
      console.error(err);
    }
  },
  [types.PRINT_UNAPPROVEDS]: async (context, payload) => {
    try {
      return await axios.post(`shipment-actions/bulk-agents-print`, {
        shipment_ids: payload.shipment_ids,
        search: payload.search ? JSON.parse(payload.search) : null,
        searchTerm: payload.searchTerm,
        total_count: payload.count,
      }).then((res) => {
        if(res.data.data.processed.length > 0 ) {
          context.dispatch('STORE_IN_QUEUE', {
            progressId: res.data.data.progress_id,
            fileName: 'Unapproved shipments',
            iconName: 'printer',
          });
        }
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  // SHARED SHIPMENTS
  [types.GET_SHARED_SHIPMENTS]: async (context, payload) => {
    try {
      await axios.get(`shipment/get-shared-list?page=${payload.page}${payload.query}`).then((res) => {
        if(payload.page == 1){
          context.commit('RESET_SHARED_SHIPMENTS', res.data.data);
        } else {
          context.commit('STORE_SHARED_SHIPMENTS', res.data.data);
        }
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_SHARED_SHIPMENTS]: ({commit}, payload) => {
    commit('STORE_SHARED_SHIPMENTS', payload);
  },
  [types.CLEAR_SHARED_SHIPMENTS]: (context) => {
    context.commit('CLEAR_SHARED_SHIPMENTS');
  },
  // SINGLE SHIPMENT ACTIONS
  [types.GET_SHIPMENT]: async (context, payload) => {
    try {
      return await axios.get(`shipment/${payload}/get`).then((res) => {
        return res.data.data.item;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_SHIPMENT]: async (context, payload) => {
    context.commit('STORE_SHIPMENT', payload);
  },
  [types.CLEAR_SHIPMENT]: (context) => {
    context.commit('CLEAR_SHIPMENT');
  },
  [types.EMAIL_WAYBILLS]: async (context, payload) => {
    try {
      await axios.get(`shipment-actions/label-to-mail?id=${payload.id}&email=${JSON.stringify(payload.emails)}&user_message=${payload.message}`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.UPLOAD_ADDITIONAL_FILE]: async (context, payload) => {
    try {
      await axios.post(`shipment-actions/${payload.shipment_id}/upload-additional-file/${payload.type}`, payload.file);
    } catch (err) {
      console.error(err);
    }
  },
  [types.HOLD_SHIPMENT]: async (context, payload) => {
    try {
      await axios.get(`shipment-actions/put-on-hold?shipment_ids=${payload}`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.UNHOLD_SHIPMENT]: async (context, payload) => {
    try {
      await axios.get(`shipment-actions/unhold?shipment_ids=${payload}`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.CANCEL_SHIPMENT]: async (context, payload) => {
    try {
      return await axios.get(`shipment-actions/cancel?shipment_ids=[${payload}]`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_SENDERS]: async (context) => {
    try {
      await axios.get('sender').then((res) => {
        context.commit('STORE_SENDERS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_SHIPPERS]: async (context, payload) => {
    try {
      let url = 'utilities/get-shipper-locations';
      if (payload && payload.type) {
        url += `?type=${payload.type}`;
      }
      return await axios.get(url).then((res) => {
        context.commit('STORE_SHIPPERS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_BROKERS]: async (context) => {
    try {
      let url = 'utilities/get-shipper-locations?type=3';
      return await axios.get(url).then((res) => {
        context.commit('STORE_BROKERS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_PALLETE_TYPES]: async (context) => {
    try {
      return await axios.get('utilities/get-pallet-types').then((res) => {
        context.commit('STORE_PALLETE_TYPES', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_PARCEL_TYPES]: async (context) => {
    try {
      return await axios.get('utilities/get-booking-packaging-options').then((res) => {
        context.commit('STORE_PARCEL_TYPES', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CLEAR_PARCEL_TYPES]: async (context) => {
    context.commit('CLEAR_PARCEL_TYPES');
  },
  [types.GET_DANGEROUS_GOODS]: async (context) => {
    try {
      return await axios.get('utilities/get-dangerous-goods').then((res) => {
        context.commit('STORE_DANGEROUS_GOODS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_AVAILABLE_PRODUCTS]: async (context, payload) => {
    try {
      return await axios.post('rate/get-freight', payload).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.BOOK_SHIPMENT]: async (context, payload) => {
    try {
      return await axios.post('shipment/create', payload).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SAVE_DRAFT]: async (context, payload) => {
    try {
      return await axios.post('shipment/save-draft', payload).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_SCAN_IMAGE]: async (context, payload) => {
    try {
      return await axios.get(`shipment-actions/${payload}/download-scan-images`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_POD]: async (context, payload) => {
      return await axios.get(`shipment-actions/${payload}/download-scan-pod`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
  },
  [types.GET_CMR]: async (context, payload) => {
    return await axios.get(`shipment-actions/${payload}/download-cmr`, {responseType: 'blob'}).then((res) => {
      return res.data;
    });
  },
  [types.GET_DG_FILE]: async (context, payload) => {
    try {
      return await axios.get(`shipment-actions/${payload}/download-dg-file`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_LABEL]: async (context, payload) => {
    try {
      return await axios.get(`shipment-actions/${payload}/label`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_LABEL_IMAGE]: async (context, payload) => {
    try {
      return await axios.get(`shipment-actions/${payload}/download-label-image`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DOWNLOAD_CONSOLIDATION_WAYBILL]: async (context, payload) => {
    try {
      return await axios.get(`consolidation/${payload.id}/download-waybill`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_CUSTOMS_DECLARABLE]: async (context, payload) => {
    try {
      return await axios.get(`utilities/get-is-customs-declarable?sender_country_id=${payload.fromCountry}&sender_postcode=${payload.fromPostcode}&receiver_country_id=${payload.toCountry}&receiver_postcode=${payload.toPostcode}&goods_type=${payload.goods_type}`).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_PAYMENT_TERMS]: async (context, payload) => {
    try {
      let urlString = payload.incoterms != null ? `&goods_incoterm=${payload.incoterms}` : '';
      return await axios.get(`utilities/get-payment-terms-services?category=${payload.category}${urlString}`).then((res) => {
        return res;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_PALLET_EXCHANGE_SERVICE]: async (context, payload) => {
    try {
      return await axios.get(`utilities/get-pallet-exchange-services?category=${payload.category}`).then((res) => {
        return res;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_ADDITIONAL_FILE_TYPES]: async (context, payload) => {
    try {
      return await axios.get(`popup-data/get-additional-file-types-by-agent?shipping_agent_id=${payload.agent}`).then((res) => {
        context.commit('STORE_ADDITIONAL_FILE_TYPES', res.data.data);
        return res;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_OPTIONS_FOR_WAYBILL_PRINTERS]: async (context) => {
    try {
      await axios.get(`popup-data/get-label-printers`).then((res) => {
        context.commit('STORE_OPTIONS_FOR_WAYBILL_PRINTERS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_CUSTOMS_PDF]: async (context, payload) => {
    try {
      return await axios.get(`shipment-actions/${payload}/download-customs-file`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_ADDITIONAL_FILE]: async (context, payload) => {
    try {
      return await axios.get(`shipment-actions/${payload.shipment_id}/download-additional-file/${payload.type}`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_SHIPMENT_FILE]: async (context, payload) => {
    try {
      return await axios.get(`shipment-actions/${payload.shipment_id}/download-file/${payload.type}`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  // End of day page
  [types.GET_SINGLE_EOD_SHIPMENTS]: async (context, payload) => {
    try {
      return await axios.get(`/end-of-day/${payload.id}/get-shipments`).then((res) => {
        context.commit('STORE_SINGLE_EOD_SHIPMENTS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CREATE_EOD]: async (context, payload) => {
    try {
      return await axios.get(`/end-of-day/create?shipment_ids=[${payload}]`).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_SHIPMENTS_EOD]: async (context, payload) => {
    try {
      return await axios.get(`end-of-day/get-list?page=${payload}`).then((res) => {
        const mutation = payload === 1 ? 'RESET_SHIPMENTS_EOD' : 'STORE_SHIPMENTS_EOD';
        context.commit(mutation, res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_ONE_EOD]: async (context, payload) => {
    try {
      return await axios.get(`end-of-day/${payload}/get`).then((res) => {
        context.commit('STORE_SINGLE_EOD', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CLEAR_EOD_SINGLE]: (context) => {
    context.commit('CLEAR_EOD_SINGLE');
  },
  [types.DOWNLOAD_EOD]: async (context, payload) => {
    try {
      return await axios.get(`/end-of-day/${payload}/download-pdf`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.PRINT_EOD]: async (context, payload) => {
    try {
      const eodId = typeof payload === 'object' ? payload.id : payload;
      const printerId = typeof payload === 'object' ? payload.printer_id : null;
      let url = `/end-of-day/${eodId}/print` + (printerId ? `?printer_id=${printerId}` : '');
      return await axios.get(url, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.PRINT_LABEL]: async (context, payload) => {
    try {
      let url = `/utilities/reprint-label?shipment_id=${payload.shipment_id}` + (payload.printer_id ? `&printer_id=${payload.printer_id}` : '')
      return await axios.get(url, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.REMOVE_SHIPMENT_EOD]: async (context, payload) => {
    try {
      return await axios.post(`/end-of-day/${payload.eodId}/remove-shipments?shipment_ids=[${payload.shipmentsIds}]`).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_EOD_SHIPMENTS]: async (context, payload) => {
    try {
      return await axios.post(`/end-of-day/create-by-date-range-and-agent?from_date=${payload.fromDate}&to_date=${payload.toDate}&agent_ids=${payload.carriers}&subaccounts=${payload.subaccounts}&countries=${payload.countries}`).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CLEAR_SINGLE_EOD_SHIPMENTS]: (context) => {
    context.commit('CLEAR_SINGLE_EOD_SHIPMENTS');
  },
  //CONSOLIDATIONS
  [types.GET_CONSOLIDATIONS]: async (context, payload) => {
    try {
      return await axios.get(`consolidation/get-list?page=${payload}`).then((res) => {
        const mutation = payload === 1 ? types.RESET_CONSOLIDATIONS : types.STORE_CONSOLIDATIONS;
        context.commit(mutation, res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_CONSOLIDATION]: async (context, payload) => {
    try {
      return await axios.get(`consolidation/${payload}/get`).then((res) => {
        context.commit(types.STORE_SINGLE_CONSOLIDATION, res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CREATE_CONSOLIDATION]: async (context, payload) => {
    try {
      return await axios.post(`/consolidation/consolidate`, payload).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_CONSOLIDATION_SHIPMENTS]: async (context, payload) => {
    try {
      return await axios.get(`consolidation/${payload.id}/get-shipments?page=${payload.page}`).then((res) => {
        context.commit(types.STORE_CONSOLIDATION_SHIPMENTS, res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_CONSOLIDATION_CARRIER_ACCOUNTS]: async (context, payload) => {
    try {
      return await axios.get(`popup-data/get-accounts-by-agent?agent_id=${payload.shipping_agent_id}`).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_AVAILABLE_CONSOLIDATIONS]: async (context, payload) => {
    try {
      return await axios.post(`consolidation/get-available-consolidations`, payload).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.PRINT_CONSOLIDATION]: async (context, payload) => {
    try {
      return await axios.post(`consolidation/${payload}/print`, {}).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CREATE_WAYBILL_AND_ROUTING_LABEL]: async (context, payload) => {
    try {
      return await axios.post(`consolidation/${payload.id}/create-waybill`, payload.form).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_WAYBILL_AND_ROUTING_LABEL]: async (context, payload) => {
    try {
      return await axios.put(`consolidation/${payload.id}/edit-waybill`, payload.form).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.COMPLETE_CONSOLIDATION_WAYBILL]: async (context, payload) => {
    try {
      return await axios.post(`consolidation/${payload}/complete-waybill`, {}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.REMOVE_SHIPMENTS_FROM_CONSOLIDATION]: async (context, payload) => {
    try {
      return await axios.delete(`consolidation/${payload.id}/remove-from-consolidation?shipment_ids=[${payload.shipment_ids}]`,).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CLEAR_SINGLE_CONSOLIDATION]: (context) => {
    context.commit(types.CLEAR_SINGLE_CONSOLIDATION);
  },
  [types.CLEAR_CONSOLIDATION_SHIPMENTS]: (context) => {
    context.commit(types.CLEAR_CONSOLIDATION_SHIPMENTS);
  },
  [types.GET_LAST_USED_WAYBILL_DATA]: async (context, payload) => {
    try {
      return await axios.get(`consolidation/${payload.id}/get-last-waybill-data?agent_id=${payload.agent_id}`).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  // EDITING SHIPMENTS ACTIONS
  [types.GET_SINGLE_DRAFT]: async (context, payload) => {
    try {
      return await axios.get(`shipment/${payload}/get`).then((res) => {
        return res.data.data.item;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_SINGLE_UNAPPROVED]: async (context, payload) => {
    try {
      return await axios.get(`shipment/${payload}/get`).then((res) => {
        return res.data.data.item;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_EDITING_SHIPMENT]: async (context, payload) => {
    context.commit('SET_EDITING_SHIPMENT', payload);
  },
  [types.CLEAR_EDITING_SHIPMENT]: async (context) => {
    context.commit('CLEAR_EDITING_SHIPMENT');
  },
  [types.GET_TRACKING_LINK]: async (context, payload) => {
    try {
      return await axios.get(`utilities/get-tracking-link?shipment_id=${payload}`).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  // ALL SHIPMENTS ACTION
  [types.DOWNLOAD_MULTI_LABELS]: async (context, payload) => {
    try {
      return await axios.get(`/shipment-actions/download-multiple-shipment-labels?ids=[${payload}]`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GENERATE_NEW_INVOICE]: async (context, payload) => {
    try {
      if (!payload.shipment_id) {
        throw new Error('Missing shipment_id');
      }
      if (!payload.customs?.goods_incoterm) {
        throw new Error('Incoterms is required');
      }
      if (!payload.additional_info?.invoiceType) {
        throw new Error('Reason for export is required');
      }
      if (!payload.content_lines || payload.content_lines.length === 0) {
        throw new Error('At least one content line is required');
      }

      return await axios.post('/shipment-actions/generate-new-invoice', payload).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  [types.GENERATE_ACTION]: async (context, payload) => {
    try {
      return await axios.post(`/shipment-actions/${payload}/generate`, {}).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
};
